import {useMutation} from '@apollo/react-hooks';

import type {
    MeetingUndeleteInput,
    UndeleteMeeting as UndeleteMeetingMutation,
    UndeleteMeetingVariables as UndeleteMeetingMutationVariables,
    GetMeetings as GetMeetingsQuery,
} from 'nutshell-graphql-types';

import UNDELETE_MEETING from '../mutations/undelete-meeting.graphql';
import GET_MEETINGS from '../queries/get-meetings.graphql';

export function useUndeleteMeeting(input: {
    entityIds?: string[];
    archived: boolean;
}): (arg1: MeetingUndeleteInput) => Promise<any> {
    const [undeleteMeeting] = useMutation<
        UndeleteMeetingMutation,
        UndeleteMeetingMutationVariables
    >(UNDELETE_MEETING);

    return (undeleteInput: MeetingUndeleteInput) => {
        return undeleteMeeting({
            variables: {input: undeleteInput},

            update: (proxy, mutationResults) => {
                const cacheResult: GetMeetingsQuery | null | undefined = proxy.readQuery({
                    query: GET_MEETINGS,
                    variables: {
                        entityIds: input.entityIds,
                        archived: input.archived,
                    },
                });

                const undeletedMeeting =
                    mutationResults &&
                    mutationResults.data &&
                    mutationResults.data.meetingUndelete &&
                    mutationResults.data.meetingUndelete.meeting;

                if (!undeletedMeeting) return;

                if (cacheResult) {
                    proxy.writeQuery({
                        query: GET_MEETINGS,
                        variables: {entityIds: input.entityIds, archived: input.archived},
                        data: {
                            meetings: cacheResult.meetings.filter(
                                (meeting) => meeting.id !== undeletedMeeting.id
                            ),
                        },
                    });
                }
            },
        });
    };
}
